import {Dialog} from '@primer/react'
import type {RefObject} from 'react'

type CopilotAutomationConfigModalProps = {
  isOpen: boolean
  onClose: () => void
  returnFocusRef?: RefObject<HTMLButtonElement | null>
}

export function CopilotAutomationConfigModal({isOpen, onClose, returnFocusRef}: CopilotAutomationConfigModalProps) {
  if (!isOpen) return null

  return (
    <Dialog title="Add Automation" onClose={onClose} returnFocusRef={returnFocusRef}>
      <p>configuration ux goes here</p>
    </Dialog>
  )
}
